import { sva } from "@agapi/ui/panda/css";
export const expandableStyles = sva({
    slots: ['root', 'stack', 'motionBox', 'rotateIcon'],
    base: {
        root: {
            overflow: 'hidden',
            position: 'relative'
        },
        stack: {
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            bottom: '0',
            left: '0',
            right: '0',
            pt: 'normal',
            pb: '3',
            pointerEvents: 'none'
        },
        motionBox: {
            transition: '.3s',
            maskImage: 'linear-gradient(to top, rgba(0, 0, 0, 0) 0px, rgba(0, 0, 0, 1) 33px)'
        },
        rotateIcon: {
            transition: '0.18s',
            transform: 'rotate(0deg)'
        }
    }
});
